// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1-lYg","inner":"Footer_inner__2fM8v"};